import React from "react";
import SharedHeader from "../../../components/Shared/Header";

const Header = () => <SharedHeader title="Kunde 2" />;

export default Header;
